import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Calendar, Clock, FileText, CalendarDays, ArrowUp, TrendingDown } from "lucide-react";
import { cn } from "@/lib/utils";

type StatCardProps = {
  title: string;
  value: number;
  icon: React.ElementType;
  trend: string;
  trendUp: boolean;
  color: string;
};

const StatCard = ({ title, value, icon: Icon, trend, trendUp, color }: StatCardProps) => (
  <Card className="hover:shadow-lg transition-shadow">
    <CardHeader className="flex flex-row items-center justify-between pb-2">
      <CardTitle className="text-sm font-medium">
        {title}
      </CardTitle>
      <div className={cn("p-2 rounded-full", color)}>
        <Icon className="h-4 w-4 text-white" />
      </div>
    </CardHeader>
    <CardContent>
      <div className="text-2xl font-bold">{value}</div>
      <div className="flex items-center mt-1">
        <span className={cn(
          "flex items-center gap-1 text-sm",
          trendUp ? "text-green-500" : "text-red-500"
        )}>
          {trendUp ? <ArrowUp className="h-3 w-3" /> : <TrendingDown className="h-3 w-3" />}
          {trend}
        </span>
      </div>
    </CardContent>
  </Card>
);

type AppointmentStatsProps = {
  appointments: any[];
  upcomingAppointments: any[];
  pastAppointments: any[];
  thisMonthAppointments: any[];
};

export const AppointmentStats = ({ 
  appointments, 
  upcomingAppointments, 
  pastAppointments, 
  thisMonthAppointments 
}: AppointmentStatsProps) => {
  const stats = [
    {
      title: "Total des rendez-vous",
      value: appointments?.length || 0,
      icon: Calendar,
      trend: "+12%",
      trendUp: true,
      color: "bg-blue-500"
    },
    {
      title: "Rendez-vous à venir",
      value: upcomingAppointments?.length || 0,
      icon: Clock,
      trend: "+5%",
      trendUp: true,
      color: "bg-green-500"
    },
    {
      title: "Rendez-vous passés",
      value: pastAppointments?.length || 0,
      icon: FileText,
      trend: "+8%",
      trendUp: true,
      color: "bg-purple-500"
    },
    {
      title: "Ce mois-ci",
      value: thisMonthAppointments?.length || 0,
      icon: CalendarDays,
      trend: "-3%",
      trendUp: false,
      color: "bg-orange-500"
    }
  ];

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      {stats.map((stat, index) => (
        <StatCard key={index} {...stat} />
      ))}
    </div>
  );
};